export const thunkTypes = {
  CONFIRM_DELIVERY: `deliveries/confirmDelivery`,
};
